module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-159.5efbc1a2.svg";